import './App.css';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/homePage.jsx'
import AchivementsPage from './pages/achivementsPage.jsx';
import SkillsPage from './pages/skilsPage.jsx';
import ExperiencePage from './pages/experiencePage.jsx';
import EducationPage from './pages/educationPage.jsx';
import ProjectPage from './pages/projectsPage.jsx';
import CertificatesPage from './pages/certificatesPage.jsx';
import ContactPage from './pages/contactPage.jsx'

function App() {
  return (
    <div className="App">
      <BrowserRouter>
          <Routes> 
            <Route path="/" element={<HomePage/>}/>
            <Route path="/achievements" element={<AchivementsPage/>}/>
            <Route path="/Skills" element={<SkillsPage/>}/>
            <Route path="/Experience" element={<ExperiencePage/>}/>
            <Route path="/Education" element={<EducationPage/>}/>
            <Route path="/Projects" element={<ProjectPage/>}/>
            <Route path="/Certificates" element={<CertificatesPage/>}/>
            <Route path="/Contact" element={<ContactPage/>}/>
          </Routes>
      </BrowserRouter>
      <ToastContainer/>
    </div>
  );
}

export default App;
